import { define, Model, AttributesMixin } from "@type-r/models";

@define
export class UserMini extends Model {
    static attributes = {
        firstName: String,
        lastName: String,
        createdBy: String,
        createdOn: Date,
        email: String,
        isActive: Boolean,
        isAgreedToTerms: Boolean,
        isCognitoIntegrated: Boolean,
        isDeleted: Boolean,
        middleInitial: String,
        relationshipParticipantUser: Array,
        salesforceId: String,
        title: String,
        updatedBy: String,
        updatedOn: Date,
        userName: String,
        userParticipant: Array,
        userPermission: Array,
        uuid: String,
        workPhone: String
    };
}
export interface UserMini extends AttributesMixin<typeof UserMini> { }

@define
export class Tuple extends Model {
    static attributes = {
        item1: String,
        item2: Array
    };

    static idAttribute = "item1"
}
export interface Tuple extends AttributesMixin<typeof Tuple> { }

export const Permissions = [
    "AllInBlockAdminWrite",
    "AllInBlockAdminViewOnly",
    "AllInBlockSuperuser",
    "OrderManagementSupplierAdmin",
    "OrderManagementSupplierMetrics",
    "OrderManagementSupplierRead",
    "OrderManagementSupplierSupersupplier",
    "OrderManagementSupplierWrite",
    "OrderManagementCustomerAdmin",
    "OrderManagementCustomerRead",
    "OrderManagementCustomerWrite",
    "OrderManagementOtherAdmin",
    "OrderManagementOtherRead",
    "InvoiceManagementSupplierAdmin",
    "InvoiceManagementSupplierMetrics",
    "InvoiceManagementSupplierRead",
    "InvoiceManagementSupplierSupersupplier",
    "InvoiceManagementSupplierWrite",
    "InvoiceManagementSupplierApprover",
    "InvoiceManagementCustomerAdmin",
    "InvoiceManagementCustomerRead",
    "InvoiceManagementCustomerWrite",
    "InvoiceManagementCustomerApprover",
    "InvoiceManagementOtherAdmin",
    "InvoiceManagementOtherRead",
    "InmatchAdmin",
    "InmatchSupplierMetrics",
    "InmatchSupplierRead",
    "InmatchSupplierAnalyst",
    "InmatchSupplierManager",
    "InmatchOtherAdmin",
    "InmatchOtherRead",
    "InmatchSupplierCollector"
]

export const Roles = [
    "Admin",
    "Customer",
    "Supplier",
    "Other",
    "CustomerParent",
    "SupplierParent",
    "Owner"
]